export const all_routes = {
  home: "/",

  // Blog Routes
  blogGrid: "/blog/blog-grid",
  blogGridSidebarRight: "/blog/blog-grid-sidebar-right",
  blogGridSidebarLeft: "/blog/blog-grid-sidebar-left",
  blogList: "/blog/blog-list",
  blogListSidebarRight: "/blog/blog-list-sidebar-right",
  blogListSidebarLeft: "/blog/blog-list-sidebar-left",
  blogCarousel: "/blog/blog-carousel",
  blogDetails: "/blog/blog-details",
  blogDetailsSidebarRight: "/blog/blog-details-sidebar-right",
  blogDetailsSidebarLeft: "/blog/blog-details-sidebar-left",

  // Pages Routes
  aboutUs: "/about-us",
  comingSoon: "/coming-soon",
  error404: "/error-404",
  events: "/events",
  eventDetails: "/event-details/:id",
  termsCondition: "/terms-condition",
  testimonials: "/testimonials",
  testimonialsCarousel: "/testimonials-carousel",
  maintenance: "/maintenance",
  privacyPolicy: "/privacy-policy",
  pricing: "/pricing",
  features: "/features",
  ourTeams: "/our-teams",
  myProfile: "/my-profile",
  faq: "/faq",
  gallery: "/gallery",
  invoice: "/coaches/invoice",
  lessonOrderConfirm: "/coaches/lesson-order-confirm",
  lessonPayment: "coaches/lesson-payment",
  lessonPersonalInfo: "coaches/lesson-personal-info",
  userWallet: "/user/user-wallet",

  // Coaches Routes
  bookingCancelled: "/coaches/booking-cancelled",
  bookingCompleted: "/coaches/booking-completed",
  allCourt: "/coaches/all-court",
  appointmentDetails: "/coaches/appointment-details",
  addCourt: "/coaches/add-court",
  activeCourt: "/coaches/active-court",
  inactiveCourt: "/coaches/inactive-court",
  coachDetail: "/coaches/coach-detail",
  coachDetails: "/coaches/coach-details",
  coachEarning: "/coaches/coach-earning",
  coachesGrid: "/coaches/coaches-grid",
  coachesGridSidebar: "/coaches/coaches-sidebar-grid",
  coachesList: "/coaches/coaches-list",
  coachesListSidebar: "/coaches/coaches-sidebar-list",
  coachesMap: "/coaches/coaches-map",
  coachRequest: "/coaches/coach-request",
  coachWallet: "/coaches/coach-wallet",
  coachTimeDate: "/coaches/coach-time-date",
  coachProfile: "/coaches/coach-profile",
  coachPersonalInfo: "/coaches/coach-personal-info",
  coachPayment: "/coaches/coach-payment",
  coachOrderConfirm: "/coaches/coach-order-confirm",
  coachesMapSidebar: "/coaches/coaches-map-sidebar",
  earningCoaching: "/coaches/earning-coaching",
  cageCheckout: "/coaches/cage-checkout",
  cageDetails: "/coaches/cage-details",
  cageOrderConfirm: "/coaches/cage-order-confirm",
  cagePersonalInfo: "/coaches/cage-personal-info",
  lessonTimeDate: "/coaches/lesson-time-date",
  lessonType: "/coaches/lesson-type",
  settingLesson: "/coaches/setting-lesson",
  settingPassword: "/coaches/setting-password",
  settingAvailability: "/coaches/setting-availability",
  profileOtherSetting: "/coaches/user-profile-other-setting",
  coachDashboard: "/coaches/coach-dashboard",
  coachBooking: "/coaches/coach-booking",
  coachChat: "/coaches/coach-chat",
  venueDetails: "/coaches/venue-details/:id",

  // User Routes
  userComplete: "/user/user-complete",
  userDashboardProfiles: "/user/user-dashboard-profiles",
  userDashboard: "/user/user-dashboard",
  userInvoice: "/user/user-invoice",
  userBookings: "/user/user-bookings",
  userChat: "/user/user-chat",
  userCoaches: "/user/user-coaches",
  userProfile: "/user/user-profile",
  userSettingPassword: "/user/user-setting-password",
  userProfileOtherSetting: "/user/user-profile-other-setting",
  userCancelled: "/user/user-cancelled",
  userOngoing: "/user/user-ongoing",

  // Listing Routes
  listingGridSidebar: "/listing/listing-grid-sidebar",
  listingGrid: "/listing/listing-grid",
  listingListSidebar: "/listing/listing-list-sidebar",
  listingList: "/listing/listing-list",
  listingMapSidebar: "/listing/listing-map-sidebar",
  listingMap: "/listing/listing-map",

  // Auth Routes
  register: "/auth/register",
  login: "/auth/login",
  changePassword: "/auth/change-password",
  forgotPassword: "/auth/forgot-password",

  //contact-us
  contactUs: "/contact-us",

  // video-analysis
  videoAnalysis: "/video-analysis/:slug",
  videoAnalysisDefault: "/video-analysis",

  // one-to-one service
  oneToOneService: "/one-to-one/:slug",
  oneToOneDefault: "/one-to-one",

  // Services Routes
  allServices: "/all-services",
  serviceDetail: "/services/:id",

  //dashboard
  dashboard: "/dashboard",

  contacts: "/dashboard/contacts",

  // video dashboard
  dashboardVideos: "/dashboard/videos",
  createVideo: "/dashboard/videos/add",
  updateVideo: "/dashboard/videos/edit/:id",

  //services
  dashboardServices: "/dashboard/services",
  createService: "/dashboard/services/add",
  updateService: "/dashboard/services/edit/:id",

  //testimonials
  dashboardTestimonials: "/dashboard/testimonials",
  createTestimonial: "/dashboard/testimonials/add",
  updateTestimonial: "/dashboard/testimonials/edit/:id",
  testimonialDetail: "/testimonials/testimonial/:id",
  testimonialsShow: "/testimonials",

  //gallery
  dashboardGallery: "/dashboard/gallery",
  addGallery: "/dashboard/gallery/add",
  editGallery: "/dashboard/gallery/edit/:id",

};
